// // ─── src/admin/pages/ProjectsPage.jsx ────────────────────────────────────────

// import React, { useEffect, useState } from 'react';
// import {
//   Table, Button, Modal, Form, Input, InputNumber,
//   Space, Tag, Popconfirm, message, Typography, Grid, Alert,
// } from 'antd';
// import { PlusOutlined, EditOutlined, DeleteOutlined, LinkOutlined } from '@ant-design/icons';
// import { projectsService } from '../firebase/services';
// import { useThemeColors } from '../hooks/Usethemecolors';
// import ColorSelect from '../components/ColorSelect';

// const { Title } = Typography;
// const { useBreakpoint } = Grid;

// export default function ProjectsPage() {
//   const [data,      setData]      = useState([]);
//   const [loading,   setLoading]   = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editing,   setEditing]   = useState(null);
//   const [form]      = Form.useForm();
//   const screens     = useBreakpoint();
//   const isMobile    = !screens.md;

//   // ── Controlled color state — kept outside form ────────────────────────────
//   // Mirrors CertificatesPage: Ant Design Form does not relay value/onChange
//   // reliably to custom components using complex dropdown rendering.
//   // We manage color separately and merge it into the payload at save time.
//   const [selectedColor, setSelectedColor] = useState('#c8f04a');

//   // ── Live theme colors from Firestore ───────────────────────────────────────
//   const { themeColors, loading: themeLoading, error: themeError } = useThemeColors();

//   const load = async () => {
//     setLoading(true);
//     try { setData(await projectsService.getAll()); }
//     catch (e) { message.error('Failed to load projects'); }
//     finally { setLoading(false); }
//   };

//   useEffect(() => { load(); }, []);

//   // ── Open modal ─────────────────────────────────────────────────────────────
//   const openAdd = () => {
//     setEditing(null);
//     form.resetFields();
//     const defaultColor = themeColors.find(c => c.varName === '--acid')?.hex || '#c8f04a';
//     setSelectedColor(defaultColor);
//     form.setFieldsValue({ order: data.length + 1 });
//     setModalOpen(true);
//   };

//   const openEdit = (record) => {
//     setEditing(record);
//     setSelectedColor(record.color || '#c8f04a');
//     form.setFieldsValue({
//       num:   record.num,
//       title: record.title,
//       type:  record.type,
//       year:  record.year,
//       url:   record.url,
//       tags:  record.tags?.join(', '),
//       desc:  record.desc,
//       order: record.order,
//     });
//     setModalOpen(true);
//   };

//   // ── Save ───────────────────────────────────────────────────────────────────
//   const handleSave = async () => {
//     try {
//       const vals = await form.validateFields();
//       const payload = {
//         ...vals,
//         color: selectedColor,                                          // ← merged here
//         tags: vals.tags ? vals.tags.split(',').map(t => t.trim()).filter(Boolean) : [],
//       };
//       if (editing) {
//         await projectsService.update(editing.id, payload);
//         message.success('Project updated');
//       } else {
//         await projectsService.add(payload);
//         message.success('Project added');
//       }
//       setModalOpen(false);
//       load();
//     } catch (e) {
//       if (e?.errorFields) return;
//       message.error('Save failed');
//     }
//   };

//   // ── Delete ─────────────────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     try {
//       await projectsService.remove(id);
//       message.success('Deleted');
//       load();
//     } catch { message.error('Delete failed'); }
//   };

//   // ── Table columns ──────────────────────────────────────────────────────────
//   const columns = [
//     {
//       title: '#',
//       dataIndex: 'num',
//       width: 44,
//       responsive: ['md'],
//     },
//     {
//       title: 'Title',
//       dataIndex: 'title',
//       render: (t, r) => (
//         <Space direction={isMobile ? 'vertical' : 'horizontal'} size={4}>
//           <span style={{ fontWeight: 600 }}>{t}</span>
//           <Space size={4} wrap>
//             <Tag color={r.color} style={{ color: '#000', fontSize: 11 }}>{r.type}</Tag>
//             {isMobile && r.year && <Tag style={{ fontSize: 11 }}>{r.year}</Tag>}
//           </Space>
//         </Space>
//       ),
//     },
//     {
//       title: 'Year',
//       dataIndex: 'year',
//       width: 70,
//       responsive: ['md'],
//     },
//     {
//       title: 'Tags',
//       dataIndex: 'tags',
//       responsive: ['lg'],
//       render: tags => tags?.map(t => <Tag key={t}>{t}</Tag>),
//     },
//     {
//       title: 'Color',
//       dataIndex: 'color',
//       width: 60,
//       responsive: ['lg'],
//       render: c => (
//         <div style={{
//           width: 24, height: 24, borderRadius: 4,
//           background: c, border: '1px solid #333',
//         }} />
//       ),
//     },
//     {
//       title: 'URL',
//       dataIndex: 'url',
//       width: 60,
//       responsive: ['md'],
//       render: u => u
//         ? <a href={u} target="_blank" rel="noreferrer"><LinkOutlined /></a>
//         : '—',
//     },
//     {
//       title: 'Actions',
//       width: 80,
//       render: (_, r) => (
//         <Space size={4}>
//           <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(r)} />
//           <Popconfirm title="Delete this project?" onConfirm={() => handleDelete(r.id)}>
//             <Button size="small" danger icon={<DeleteOutlined />} />
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   // ── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <div style={{
//         display: 'flex', justifyContent: 'space-between',
//         alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8,
//       }}>
//         <Title level={4} style={{ margin: 0 }}>Projects</Title>
//         <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>
//           Add Project
//         </Button>
//       </div>

//       {themeError && (
//         <Alert message={themeError} type="warning" showIcon closable style={{ marginBottom: 12 }} />
//       )}

//       <Table
//         rowKey="id"
//         dataSource={data}
//         columns={columns}
//         loading={loading}
//         pagination={{ pageSize: 8, simple: isMobile }}
//         size={isMobile ? 'small' : 'middle'}
//         scroll={{ x: 'max-content' }}
//       />

//       {/* ── Modal ──────────────────────────────────────────────────────────── */}
//       <Modal
//         title={editing ? 'Edit Project' : 'Add Project'}
//         open={modalOpen}
//         onOk={handleSave}
//         onCancel={() => setModalOpen(false)}
//         okText="Save"
//         width={isMobile ? '100%' : 600}
//         style={isMobile ? { top: 0, margin: 0, padding: 0, maxWidth: '100vw' } : {}}
//         styles={isMobile ? { body: { padding: '12px 16px' } } : {}}
//       >
//         <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
//           <Form.Item name="num" label="Number" rules={[{ required: true }]}>
//             <Input placeholder="01" />
//           </Form.Item>
//           <Form.Item name="title" label="Title" rules={[{ required: true }]}>
//             <Input />
//           </Form.Item>
//           <Form.Item name="type" label="Type" rules={[{ required: true }]}>
//             <Input placeholder="Finance Website" />
//           </Form.Item>
//           <Form.Item name="year" label="Year" rules={[{ required: true }]}>
//             <Input placeholder="2025" />
//           </Form.Item>
//           <Form.Item name="url" label="URL">
//             <Input placeholder="https://..." />
//           </Form.Item>
//           <Form.Item name="tags" label="Tags (comma separated)">
//             <Input placeholder="React.js, Node.js, Express.js" />
//           </Form.Item>
//           <Form.Item name="desc" label="Description" rules={[{ required: true }]}>
//             <Input.TextArea rows={3} />
//           </Form.Item>

//           {/* ── Accent Color — controlled outside Form, same as CertificatesPage ── */}
//           <Form.Item label="Accent Color" required>
//             {/* Live swatch preview of currently selected color */}
//             <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
//               <div style={{
//                 width: 28, height: 28, borderRadius: 4,
//                 background: selectedColor,
//                 border: '1px solid #d9d9d9',
//                 flexShrink: 0,
//               }} />
//               <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 12, color: '#555' }}>
//                 {selectedColor.toUpperCase()}
//               </span>
//             </div>
//             <ColorSelect
//               value={selectedColor}
//               onChange={setSelectedColor}
//               themeColors={themeColors}
//               loading={themeLoading}
//               storageKey="admin_custom_colors_projects"
//             />
//           </Form.Item>

//           <Form.Item name="order" label="Order">
//             <InputNumber min={1} style={{ width: '100%' }} />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </>
//   );
// }

// ─── src/admin/pages/ProjectsPage.jsx ────────────────────────────────────────

import React, { useEffect, useState } from 'react';
import {
  Table, Button, Modal, Form, Input, InputNumber,
  Space, Tag, Popconfirm, message, Typography, Grid, Alert,
  Card, Divider, Tooltip,
} from 'antd';
import {
  PlusOutlined, EditOutlined, DeleteOutlined, LinkOutlined,
  QuestionCircleOutlined, PlusCircleOutlined, MinusCircleOutlined,
  SaveOutlined, UndoOutlined,
} from '@ant-design/icons';
import { projectsService, projectsQuoteService } from '../firebase/services';
import { useThemeColors } from '../hooks/Usethemecolors';
import ColorSelect from '../components/ColorSelect';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

// ── Defaults shown when Firestore has no saved quote ─────────────
const DEFAULT_QUOTE = {
  lines:       ['about what you add,', 'but what you leave out.'],
  attribution: '',
};

/* ═══════════════════════════════════════════════════════════════════
   Quote Editor sub-component
   – Renders as a Card section on the ProjectsPage
   – Manages its own local state; save/reset call projectsQuoteService
═══════════════════════════════════════════════════════════════════ */
function QuoteEditor({ isMobile }) {
  const [lines, setLines]           = useState(DEFAULT_QUOTE.lines);
  const [attribution, setAttribution] = useState(DEFAULT_QUOTE.attribution);
  const [saving, setSaving]         = useState(false);
  const [resetting, setResetting]   = useState(false);
  const [loadError, setLoadError]   = useState('');

  // ── Load current quote from Firestore on mount ──────────────
  useEffect(() => {
    projectsQuoteService.get()
      .then(({ lines: l, attribution: a }) => {
        setLines(l);
        setAttribution(a);
      })
      .catch(() => setLoadError('Could not load saved quote — showing defaults.'));
  }, []);

  // ── Add / remove / edit lines ───────────────────────────────
  const addLine = () => setLines(prev => [...prev, '']);

  const removeLine = (i) =>
    setLines(prev => prev.filter((_, idx) => idx !== i));

  const updateLine = (i, val) =>
    setLines(prev => prev.map((l, idx) => (idx === i ? val : l)));

  // ── Save to Firestore ───────────────────────────────────────
  const handleSave = async () => {
    const cleanLines = lines.map(l => l.trim()).filter(Boolean);
    if (!cleanLines.length) {
      message.warning('Add at least one line before saving.');
      return;
    }
    setSaving(true);
    try {
      await projectsQuoteService.save({ lines: cleanLines, attribution: attribution.trim() });
      setLines(cleanLines);
      message.success('Quote saved — live on the portfolio!');
    } catch {
      message.error('Save failed. Check your connection.');
    } finally {
      setSaving(false);
    }
  };

  // ── Reset to defaults (deletes Firestore doc) ───────────────
  const handleReset = async () => {
    setResetting(true);
    try {
      await projectsQuoteService.reset();
      setLines(DEFAULT_QUOTE.lines);
      setAttribution(DEFAULT_QUOTE.attribution);
      message.success('Reset to defaults.');
    } catch {
      message.error('Reset failed.');
    } finally {
      setResetting(false);
    }
  };

  return (
    <Card
      size="small"
      style={{ marginBottom: 28, borderColor: '#1f1f1f', background: '#0d0d0d' }}
      title={
        <Space>
          <Text style={{ color: '#d4f700', fontFamily: 'Space Mono, monospace', fontSize: 12 }}>
            OUTRO QUOTE
          </Text>
          <Tooltip title="These lines appear one by one in the animated outro at the end of the Projects scroll section.">
            <QuestionCircleOutlined style={{ color: '#555', fontSize: 13 }} />
          </Tooltip>
        </Space>
      }
    >
      {loadError && (
        <Alert message={loadError} type="warning" showIcon closable style={{ marginBottom: 12 }} />
      )}

      {/* ── Preview strip ──────────────────────────────────────── */}
      <div style={{
        background: '#060606',
        border: '1px solid #1a1a1a',
        borderRadius: 4,
        padding: isMobile ? '12px 14px' : '14px 20px',
        marginBottom: 16,
      }}>
        <Text style={{
          display: 'block',
          fontFamily: 'Space Mono, monospace',
          fontSize: 10,
          color: '#333',
          letterSpacing: '0.18em',
          marginBottom: 8,
        }}>
          PREVIEW
        </Text>
        {lines.filter(Boolean).map((line, i) => (
          <div key={i} style={{
            fontFamily: 'Syne, sans-serif',
            fontWeight: 800,
            fontSize: isMobile ? '1rem' : '1.3rem',
            color: '#f0f0f0',
            letterSpacing: '-0.04em',
            lineHeight: 1.2,
            opacity: 0.85,
          }}>
            {line}
          </div>
        ))}
        {attribution && (
          <div style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: '0.65rem',
            color: '#d4f700',
            letterSpacing: '0.2em',
            marginTop: 8,
          }}>
            {attribution}
          </div>
        )}
      </div>

      {/* ── Line editor ────────────────────────────────────────── */}
      <div style={{ marginBottom: 12 }}>
        <Text style={{
          display: 'block',
          fontFamily: 'Space Mono, monospace',
          fontSize: 10,
          color: '#555',
          letterSpacing: '0.12em',
          marginBottom: 8,
        }}>
          LINES  <span style={{ color: '#333' }}>(each appears sequentially in the animation)</span>
        </Text>

        <Space direction="vertical" style={{ width: '100%' }} size={6}>
          {lines.map((line, i) => (
            <Space key={i} style={{ width: '100%' }} size={6}>
              <Text style={{
                fontFamily: 'Space Mono, monospace',
                fontSize: 11,
                color: '#444',
                minWidth: 18,
                textAlign: 'right',
              }}>
                {i + 1}.
              </Text>
              <Input
                value={line}
                onChange={e => updateLine(i, e.target.value)}
                placeholder={`Line ${i + 1}`}
                style={{ flex: 1 }}
              />
              <Button
                size="small"
                danger
                icon={<MinusCircleOutlined />}
                disabled={lines.length <= 1}
                onClick={() => removeLine(i)}
              />
            </Space>
          ))}
        </Space>

        <Button
          type="dashed"
          size="small"
          icon={<PlusCircleOutlined />}
          onClick={addLine}
          style={{ marginTop: 8, width: '100%' }}
        >
          Add Line
        </Button>
      </div>

      <Divider style={{ borderColor: '#1a1a1a', margin: '12px 0' }} />

      {/* ── Attribution ────────────────────────────────────────── */}
      <div style={{ marginBottom: 16 }}>
        <Text style={{
          display: 'block',
          fontFamily: 'Space Mono, monospace',
          fontSize: 10,
          color: '#555',
          letterSpacing: '0.12em',
          marginBottom: 6,
        }}>
          ATTRIBUTION
        </Text>
        <Input
          value={attribution}
          onChange={e => setAttribution(e.target.value)}
          placeholder="— Dieter Rams"
        />
      </div>

      {/* ── Actions ────────────────────────────────────────────── */}
      <Space>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          loading={saving}
          onClick={handleSave}
        >
          Save Quote
        </Button>
        <Popconfirm
          title="Reset to default Dieter Rams quote?"
          onConfirm={handleReset}
          okText="Reset"
          cancelText="Cancel"
        >
          <Button
            icon={<UndoOutlined />}
            loading={resetting}
          >
            Reset to Default
          </Button>
        </Popconfirm>
      </Space>
    </Card>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   Main ProjectsPage
═══════════════════════════════════════════════════════════════════ */
export default function ProjectsPage() {
  const [data,      setData]      = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing,   setEditing]   = useState(null);
  const [form]      = Form.useForm();
  const screens     = useBreakpoint();
  const isMobile    = !screens.md;

  // ── Controlled color state ─────────────────────────────────────
  const [selectedColor, setSelectedColor] = useState('#c8f04a');

  // ── Live theme colors from Firestore ───────────────────────────
  const { themeColors, loading: themeLoading, error: themeError } = useThemeColors();

  const load = async () => {
    setLoading(true);
    try { setData(await projectsService.getAll()); }
    catch (e) { message.error('Failed to load projects'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  // ── Open modal ─────────────────────────────────────────────────
  const openAdd = () => {
    setEditing(null);
    form.resetFields();
    const defaultColor = themeColors.find(c => c.varName === '--acid')?.hex || '#c8f04a';
    setSelectedColor(defaultColor);
    form.setFieldsValue({ order: data.length + 1 });
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditing(record);
    setSelectedColor(record.color || '#c8f04a');
    form.setFieldsValue({
      num:   record.num,
      title: record.title,
      type:  record.type,
      year:  record.year,
      url:   record.url,
      tags:  record.tags?.join(', '),
      desc:  record.desc,
      order: record.order,
    });
    setModalOpen(true);
  };

  // ── Save ───────────────────────────────────────────────────────
  const handleSave = async () => {
    try {
      const vals = await form.validateFields();
      const payload = {
        ...vals,
        color: selectedColor,
        tags: vals.tags ? vals.tags.split(',').map(t => t.trim()).filter(Boolean) : [],
      };
      if (editing) {
        await projectsService.update(editing.id, payload);
        message.success('Project updated');
      } else {
        await projectsService.add(payload);
        message.success('Project added');
      }
      setModalOpen(false);
      load();
    } catch (e) {
      if (e?.errorFields) return;
      message.error('Save failed');
    }
  };

  // ── Delete ─────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    try {
      await projectsService.remove(id);
      message.success('Deleted');
      load();
    } catch { message.error('Delete failed'); }
  };

  // ── Table columns ──────────────────────────────────────────────
  const columns = [
    {
      title: '#',
      dataIndex: 'num',
      width: 44,
      responsive: ['md'],
    },
    {
      title: 'Title',
      dataIndex: 'title',
      render: (t, r) => (
        <Space direction={isMobile ? 'vertical' : 'horizontal'} size={4}>
          <span style={{ fontWeight: 600 }}>{t}</span>
          <Space size={4} wrap>
            <Tag color={r.color} style={{ color: '#000', fontSize: 11 }}>{r.type}</Tag>
            {isMobile && r.year && <Tag style={{ fontSize: 11 }}>{r.year}</Tag>}
          </Space>
        </Space>
      ),
    },
    {
      title: 'Year',
      dataIndex: 'year',
      width: 70,
      responsive: ['md'],
    },
    {
      title: 'Tags',
      dataIndex: 'tags',
      responsive: ['lg'],
      render: tags => tags?.map(t => <Tag key={t}>{t}</Tag>),
    },
    {
      title: 'Color',
      dataIndex: 'color',
      width: 60,
      responsive: ['lg'],
      render: c => (
        <div style={{
          width: 24, height: 24, borderRadius: 4,
          background: c, border: '1px solid #333',
        }} />
      ),
    },
    {
      title: 'URL',
      dataIndex: 'url',
      width: 60,
      responsive: ['md'],
      render: u => u
        ? <a href={u} target="_blank" rel="noreferrer"><LinkOutlined /></a>
        : '—',
    },
    {
      title: 'Actions',
      width: 80,
      render: (_, r) => (
        <Space size={4}>
          <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(r)} />
          <Popconfirm title="Delete this project?" onConfirm={() => handleDelete(r.id)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // ── Render ─────────────────────────────────────────────────────
  return (
    <>
      {/* ── Page header ──────────────────────────────────────────── */}
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8,
      }}>
        <Title level={4} style={{ margin: 0 }}>Projects</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>
          Add Project
        </Button>
      </div>

      {themeError && (
        <Alert message={themeError} type="warning" showIcon closable style={{ marginBottom: 12 }} />
      )}

      {/* ── Outro Quote editor ────────────────────────────────────── */}
      <QuoteEditor isMobile={isMobile} />

      {/* ── Projects table ────────────────────────────────────────── */}
      <Table
        rowKey="id"
        dataSource={data}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 8, simple: isMobile }}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 'max-content' }}
      />

      {/* ── Modal ──────────────────────────────────────────────────── */}
      <Modal
        title={editing ? 'Edit Project' : 'Add Project'}
        open={modalOpen}
        onOk={handleSave}
        onCancel={() => setModalOpen(false)}
        okText="Save"
        width={isMobile ? '100%' : 600}
        style={isMobile ? { top: 0, margin: 0, padding: 0, maxWidth: '100vw' } : {}}
        styles={isMobile ? { body: { padding: '12px 16px' } } : {}}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="num" label="Number" rules={[{ required: true }]}>
            <Input placeholder="01" />
          </Form.Item>
          <Form.Item name="title" label="Title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="type" label="Type" rules={[{ required: true }]}>
            <Input placeholder="Finance Website" />
          </Form.Item>
          <Form.Item name="year" label="Year" rules={[{ required: true }]}>
            <Input placeholder="2025" />
          </Form.Item>
          <Form.Item name="url" label="URL">
            <Input placeholder="https://..." />
          </Form.Item>
          <Form.Item name="tags" label="Tags (comma separated)">
            <Input placeholder="React.js, Node.js, Express.js" />
          </Form.Item>
          <Form.Item name="desc" label="Description" rules={[{ required: true }]}>
            <Input.TextArea rows={3} />
          </Form.Item>

          {/* ── Accent Color ── */}
          <Form.Item label="Accent Color" required>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <div style={{
                width: 28, height: 28, borderRadius: 4,
                background: selectedColor,
                border: '1px solid #d9d9d9',
                flexShrink: 0,
              }} />
              <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 12, color: '#555' }}>
                {selectedColor.toUpperCase()}
              </span>
            </div>
            <ColorSelect
              value={selectedColor}
              onChange={setSelectedColor}
              themeColors={themeColors}
              loading={themeLoading}
              storageKey="admin_custom_colors_projects"
            />
          </Form.Item>

          <Form.Item name="order" label="Order">
            <InputNumber min={1} style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}